import React, { useState, useEffect, useRef } from "react";
import { FormattedMessage } from "react-intl";
import Spinner from "../../../components/Spinner";

import { Row, Card, Alert, Button, Col, message, Input, Divider, } from 'antd';
import { ListInviteCodes, GenerateInviteCodes, } from '../../../services/users';
import { CopyIcon, PlusCircleIcon, UserIcon } from "@phosphor-icons/react";

const ProfileInviteView = ({
    history,
}) => {

    const [inviteCodesData, setInviteCodesData] = useState([]);
    const [dataLoading, setDataLoading] = useState(true);
    const customerID = "me";
    const webhookRef = useRef(null);
    useEffect(() => {
        LoadInviteCodes();

        return () => {
            // cleanup
            // setUserProfileData({});
            // setDetailsLoading(true);
        }
        // below line needed to remove the warning on build.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const LoadInviteCodes = () => {
        ListInviteCodes(customerID)
            .then(response => {
                if (response.status) {
                    setInviteCodesData(response.data.invite_code_list);
                }
                setDataLoading(false);
            })
            .catch(error => {
                console.error('error: ', error);
            });
    };

    const generateCodes = () => {
        setDataLoading(true);
        GenerateInviteCodes({ customer_id: customerID })
            .then(response => {
                LoadInviteCodes();
            })
            .catch(error => {
                console.error('error: ', error);
            });
    }

    return (
        <React.Fragment>
            {dataLoading ? (<Spinner />) : (

                <Row gutter={[32, 32]}>
                    <Col span={24}>

                        {/* Change password card */}
                        <Card
                            title={<h6 className="card-title"><FormattedMessage id="profile-invite" /></h6>}
                            className="mt-4"
                            loading={dataLoading}>

                            <Row>
                                <Col span={18} offset={4}>
                                    <Alert
                                        className="mb-2"
                                        title="Invite your friends"
                                        description="Traders Management is still in beta and therefore closed for signup. But you can invite up to 5 friends to try Traders Management for free."
                                        type="success"
                                        showIcon
                                        action={
                                            <>
                                                {inviteCodesData.length === 0 && (
                                                    <Button key="button" type="ghost"
                                                        className="ant-btn-success"
                                                        onClick={generateCodes}
                                                        icon={<PlusCircleIcon size={16} />}>
                                                        Click to generate your codes
                                                    </Button>
                                                )}
                                            </>
                                        }
                                    />
                                </Col>
                                {inviteCodesData.length > 0 && (
                                    <Divider orientation="left">Available invite links</Divider>
                                )}
                                {inviteCodesData.map((item, index) => (
                                    <React.Fragment key={index}>
                                        {!item.invite_code_used && (
                                            <Col span={18} offset={4} >
                                                <Input size=""
                                                    className="mt-2"
                                                    ref={webhookRef}
                                                    disabled={true}
                                                    addonBefore="Invite link:"
                                                    addonAfter={<CopyIcon size={16} onClick={(e) => {
                                                        navigator.clipboard.writeText(`${process.env.REACT_APP_WEBSITE}/signup/${item.invite_code}`);
                                                        message.success('Invite link has been copied!');
                                                    }} />}
                                                    defaultValue={`${process.env.REACT_APP_WEBSITE}/signup/${item.invite_code}`} />
                                            </Col>
                                        )}
                                    </React.Fragment>
                                ))}

                                {inviteCodesData.findIndex((item) => { return item.invite_code_used }) >= 0 && (
                                    <>
                                        <Divider orientation="left">Your friends</Divider>
                                        {inviteCodesData.map((item, index) => (
                                            <React.Fragment key={index}>
                                                {item.invite_code_used && (
                                                    <Col span={18} offset={4} >
                                                        <UserIcon size={16} /> {item.invite_code_used_by}
                                                        {/* <Input size=""
                                                    className="mt-2"
                                                    ref={webhookRef}
                                                    disabled={true}
                                                    addonBefore="Invite link:"
                                                    addonAfter={<CopyOutlined onClick={(e) => {
                                                        navigator.clipboard.writeText(`${process.env.REACT_APP_SERVER}/webhook/strategy/${item.invite_code}`);
                                                        message.success('Invite link has been copied!');
                                                    }} />}
                                                    defaultValue={`${process.env.REACT_APP_WEBSITE}/signup/${item.invite_code}`} /> */}
                                                    </Col>
                                                )}


                                            </React.Fragment>
                                        ))}
                                    </>)}
                            </Row>
                        </Card>

                    </Col>
                </Row>
            )}

        </React.Fragment>
    );
};


export default ProfileInviteView;